import React from 'react';
import './App.css';
import ParamListViewer from "../../containers/param/ParamListViewer";
import ParamCorrectLevelViewer from "../../containers/param/ParamCorrectLevelViewer";
import ParamIconViewer from "../../containers/param/disposable/ParamIconViewer";
import ScrollContainer from "react-indiana-drag-scroll";

const PartParams = () => (

    <div className="breadcomb-area">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="breadcomb-list">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="breadcomb-wp">
                                    <div className="breadcomb-ctn qr-j2 w100">
                                        <h2>外观调整</h2>
                                        <p>选择不同的参数后，可以预览二维码效果。</p>
                                        <hr />
                                        <div className="qr-table">
                                            <ParamCorrectLevelViewer/>
                                            <ParamIconViewer/>
                                            <ParamListViewer/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default PartParams;
